import React from "react";
import { Card, CardContent } from "../components/ui/card";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

export default function FracturesTraumaPage() {
  const services = [
    {
      title: "Emergency Care",
      description:
        "Immediate assessment and stabilization of acute fractures and traumatic injuries",
    },
    {
      title: "Closed Reduction",
      description:
        "Non-surgical realignment of fractures with casting or splinting",
    },
    {
      title: "Surgical Fixation",
      description:
        "Internal fixation with plates, screws, or rods for complex fractures",
    },
    {
      title: "Rehabilitation",
      description:
        "Structured recovery programs with regular progress reviews",
    },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary to-primary/90 text-primary-foreground py-16">
        <div className="mx-auto max-w-7xl px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-bold tracking-tight sm:text-5xl mb-4 font-[family-name:var(--font-playfair)]">
            Fracture & Trauma Care
          </h1>
          <p className="text-lg text-primary-foreground/90 leading-relaxed max-w-2xl mx-auto">
            Expert treatment for broken bones and traumatic injuries.
          </p>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 items-start">
            <div className="relative h-[400px] rounded-lg overflow-hidden shadow-xl">
              <img
                src="/fracture-trauma-care-orthopedic-emergency-treatmen.jpg"
                alt="Fracture treatment"
                className="object-cover w-full h-full"
              />
            </div>

            <div>
              <h2 className="text-3xl font-bold mb-6 font-[family-name:var(--font-playfair)]">
                Comprehensive Fracture Management
              </h2>
              <div className="prose prose-lg max-w-none space-y-4">
                <p className="text-foreground leading-relaxed">
                  We provide emergency and planned fracture care including
                  closed reductions, casting, surgical fixation, and
                  rehabilitation with regular progress reviews. Our approach
                  ensures optimal healing and return to function.
                </p>
                <p className="text-foreground leading-relaxed">
                  From simple fractures that can be managed with casting to
                  complex injuries requiring surgical intervention, we have the
                  expertise to guide you through every step of recovery.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-muted/30">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center mb-12 font-[family-name:var(--font-playfair)]">
            Our Services
          </h2>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 max-w-4xl mx-auto">
            {services.map((service, index) => (
              <Card key={index}>
                <CardContent className="p-6">
                  <h3 className="text-lg font-semibold mb-2">
                    {service.title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
